<template>
  <client-only>
    <v-container id="companies-section">
      <h2 class="primary--text text-center my-md-6">
        <span
          >{{ SectionCompanies.text1 }} <br class="isMobile" />{{
            SectionCompanies.text2
          }}</span
        >
      </h2>
      <v-layout
        class="section_inner"
        align-center
        justify-space-around
        text-center
        wrap
      >
        <v-flex
          v-for="(i, key) in DfpHomePage"
          :key="key"
          text-center
          class="company-item"
          d-flex
        >
          <GptAd
            class="flex-grow-1"
            :ad-unit="`3177829/${i.adunit}`"
            :size="[120, 38]"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </client-only>
</template>

<script>
import { homePage } from '@/lib/homePage.js'

export default {
  props: {
    hideTitle: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      SectionCompanies: homePage.SectionCompanies,
      DfpHomePage: {
        1: {
          adunit: 'Logo1newsite',
          id: '1585493459494-0',
        },
        2: {
          adunit: 'Logo2newsite',
          id: '1585493765398-0',
        },
        3: {
          adunit: 'Logo3newsite',
          id: '1585493850505-0',
        },
        4: {
          adunit: 'Logo4newsite',
          id: '1585494035449-0',
        },
        5: {
          adunit: 'Logo5newsite',
          id: '1585494121594-0',
        },
        6: {
          adunit: 'Logo6newsite',
          id: '1585494224909-0',
        },
      },
    }
  },
}
</script>

<style lang="scss" scoped>
#companies-section .v-card {
  box-shadow: none;
}

#companies-section .company-item {
  width: 180px;
  height: 180px;
  background-color: #f6f7f9 !important;
  border-radius: 50%;
  flex-shrink: 0;
  flex-basis: auto;
  max-width: 180px;
  place-items: center;
  justify-content: center;
  border: 1px solid #dedfe0;
}

#companies-section .company-image {
  align-self: center;
}

#companies-section .company-jobs {
  align-self: center;
}

#companies-section .companies-all button {
  margin-top: -25px;
}

.company-img {
  max-width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
}

.isMobile {
  display: none;
}

@media screen and (max-width: 1280px) {
  #companies-section .company-item {
    width: 140px;
    height: 140px;
    max-width: 140px;
  }
}

@media screen and (max-width: 1024px) {
  #companies-section .company-item {
    width: 120px;
    height: 120px;
    max-width: 120px;
  }
  #companies-section .company-item > div {
    transform: scale(0.6);
  }
}
@media screen and (max-width: 768px) {
  #companies-section .company-item {
    width: 30%;
    flex-basis: auto;
    flex-grow: 0;
    margin-top: 20px;
  }
}

@media screen and (max-width: 600px) {
  .isMobile {
    display: block;
  }
}
@media screen and (max-width: 420px) {
  #companies-section .company-item {
    justify-content: center;
  }
  #companies-section .company-item > div {
    transform: scale(0.6);
  }
}

@media screen and (max-width: 375px) {
  #companies-section .company-item {
    width: 33.33%;
    width: 90px;
    height: 90px;
    margin: 0px auto 8px;
    transform: scale(0.8);
  }
}
</style>
